
export class VerticalOverlapObserver {

    constructor(callback, target, options = { startOffset: 0, endOffset: 0 }) {
        this.callback = callback;
        this.target = target;
        this.observations = new Map(); // key: element, value: { options, lastRatio }
        this._boundCheck = this._check.bind(this);
        this.targetOptions = options
        this._start();
    }

    observe(...elementsAndOptions) {
        const options = elementsAndOptions.pop();
        const elements = elementsAndOptions;

        for (const el of elements) {
            this.observations.set(el, {
                options,
                lastRatio: null,
            });
        }
    }

    unobserve(...elements) {
        for (const el of elements) {
            this.observations.delete(el);
        }
    }

    disconnect() {
        this.observations.clear();
        window.removeEventListener("scroll", this._boundCheck);
        window.removeEventListener("resize", this._boundCheck);
    }

    _start() {
        window.addEventListener("scroll", this._boundCheck, { passive: true });
        window.addEventListener("resize", this._boundCheck);
        this._check();
    }

    _check() {
        const targetRect = this.target.getBoundingClientRect();
        const { startOffset: targetStartOffset = 0, endOffset: targetEndOffset = 0 } = this.targetOptions;

        for (const [el, data] of this.observations) {
            const elRect = el.getBoundingClientRect();
            const { startOffset = 0, endOffset = 0 } = data.options;

            const top1 = targetRect.top + targetStartOffset;
            const top2 = elRect.top + startOffset;
            const bottom1 = targetRect.bottom + targetEndOffset;
            const bottom2 = elRect.bottom + endOffset;

            const overlapTop = Math.max(top1, top2);
            const overlapBottom = Math.min(bottom1, bottom2);
            const overlapHeight = Math.max(0, overlapBottom - overlapTop);

            const referenceHeight = Math.min(targetRect.height, elRect.height);
            const ratio = Math.min(1, overlapHeight / referenceHeight);

            if (ratio !== data.lastRatio) {
                data.lastRatio = ratio;
                this.callback([
                    {
                        target: this.target,
                        element: el,
                        targetRect: targetRect,
                        elementRect: elRect,
                        ratio,
                        options: data.options,
                    },
                ]);
            }
        }
    }
}
